"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethCallFactory = void 0;
var ethCallFactory = function (fetch, rpcUrl) { return function (to, data) { return fetch(rpcUrl, {
    method: 'post',
    body: JSON.stringify({
        jsonrpc: '2.0',
        method: 'eth_call',
        id: 666,
        params: [{ to: to, data: data }, 'latest']
    }),
    headers: { 'Content-Type': 'application/json' },
}).then(function (res) { return res.json(); })
    .then(function (_a) {
    var result = _a.result, error = _a.error, id = _a.id;
    if (id !== 666)
        throw new Error('Invalid RPC response: id mismatch');
    if (error)
        throw new Error('RPC Call error: ' + JSON.stringify(error));
    return result;
}); }; };
exports.ethCallFactory = ethCallFactory;
//# sourceMappingURL=rpc.js.map